var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _g3, _g4, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 34.1326 52.6562 40.1651 48.707 44.9772C44.7578 49.7893 39.2623 53.0833 33.1567 54.2977C27.0512 55.5122 20.7134 54.5721 15.2233 51.6376C9.73325 48.703 5.4305 43.9557 3.04824 38.2044C0.665977 32.4531 0.351594 26.0537 2.15866 20.0966C3.96573 14.1395 7.78243 8.99327 12.9585 5.53476C18.1345 2.07625 24.3496 0.519452 30.5448 1.12962C36.7399 1.73979 42.5319 4.47918 46.9337 8.88103L27.9074 27.9074H54.8147Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 33.2292 53.2366 38.4314 50.28 42.8563C47.3234 47.2812 43.121 50.73 38.2044 52.7665C33.2877 54.8031 27.8775 55.3359 22.658 54.2977C17.4385 53.2595 12.6441 50.6968 8.88102 46.9338C5.11796 43.1707 2.55528 38.3763 1.51706 33.1568C0.478832 27.9372 1.01169 22.5271 3.04824 17.6104C5.08479 12.6937 8.53357 8.49138 12.9585 5.53476C17.3834 2.57815 22.5856 1.00006 27.9074 1.00006V27.9074H54.8147Z",
    fill: "#65325f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 32.3323 53.7234 36.689 51.6375 40.5914C49.5516 44.4939 46.5355 47.8217 42.8563 50.28C39.1771 52.7384 34.9484 54.2514 30.5448 54.6852C26.1411 55.1189 21.6985 54.4599 17.6104 52.7665C13.5223 51.0732 9.91488 48.3978 7.10773 44.9772C4.30057 41.5567 2.38032 37.4967 1.51706 33.1568C0.653795 28.8168 0.874169 24.331 2.15866 20.0966C3.44315 15.8622 5.75211 12.0099 8.88102 8.88104L27.9074 27.9074H54.8147Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 35.0437 51.9798 41.8877 46.9337 46.9338C41.8876 51.9799 35.0437 54.8147 27.9074 54.8147C20.7711 54.8147 13.9271 51.9799 8.88102 46.9338C3.83491 41.8877 1.00004 35.0437 1.00004 27.9074L27.9074 27.9074H54.8147Z",
    fill: "#65325f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 33.2292 53.2366 38.4314 50.28 42.8563C47.3234 47.2812 43.121 50.73 38.2044 52.7665C33.2877 54.8031 27.8775 55.3359 22.658 54.2977C17.4385 53.2595 12.6441 50.6968 8.88102 46.9338L27.9074 27.9074H54.8147Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 31.4409 54.1187 34.9398 52.7665 38.2044C51.4143 41.4689 49.4323 44.4352 46.9337 46.9338C44.4352 49.4323 41.4689 51.4143 38.2044 52.7665C34.9398 54.1188 31.4409 54.8147 27.9074 54.8147L27.9074 27.9074H54.8147Z",
    fill: "#65325f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 31.4409 54.1187 34.9398 52.7665 38.2044C51.4143 41.4689 49.4323 44.4352 46.9337 46.9338L27.9074 27.9074H54.8147Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8147 27.9074C54.8147 24.3739 54.1187 20.875 52.7665 17.6104C51.4143 14.3459 49.4323 11.3796 46.9337 8.88103L27.9074 27.9074H54.8147Z",
    fill: "#65325f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9073 45.6763C37.7209 45.6763 45.6763 37.7209 45.6763 27.9073C45.6763 18.0938 37.7209 10.1383 27.9073 10.1383C18.0938 10.1383 10.1383 18.0938 10.1383 27.9073C10.1383 37.7209 18.0938 45.6763 27.9073 45.6763ZM27.9073 50.7532C40.5247 50.7532 50.7532 40.5247 50.7532 27.9073C50.7532 15.2899 40.5247 5.06148 27.9073 5.06148C15.2899 5.06148 5.06148 15.2899 5.06148 27.9073C5.06148 40.5247 15.2899 50.7532 27.9073 50.7532Z",
    fill: "url(#paint0_radial_1_2)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9073 49.7378C39.964 49.7378 49.7378 39.964 49.7378 27.9073C49.7378 15.8507 39.964 6.07686 27.9073 6.07686C15.8507 6.07686 6.07686 15.8507 6.07686 27.9073C6.07686 39.964 15.8507 49.7378 27.9073 49.7378ZM27.9073 54.8147C42.7679 54.8147 54.8147 42.7679 54.8147 27.9073C54.8147 13.0468 42.7679 1 27.9073 1C13.0468 1 1 13.0468 1 27.9073C1 42.7679 13.0468 54.8147 27.9073 54.8147Z",
    fill: "url(#paint1_radial_1_2)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5072 27.3997C34.5072 30.7643 31.7797 33.4919 28.415 33.4919C25.0504 33.4919 22.3228 30.7643 22.3228 27.3997C22.3228 24.035 25.0504 21.3074 28.415 21.3074C31.7797 21.3074 34.5072 24.035 34.5072 27.3997Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.415 31.9688C30.9385 31.9688 32.9842 29.9232 32.9842 27.3997C32.9842 24.8762 30.9385 22.8305 28.415 22.8305C25.8915 22.8305 23.8458 24.8762 23.8458 27.3997C23.8458 29.9232 25.8915 31.9688 28.415 31.9688ZM28.415 33.4919C31.7797 33.4919 34.5072 30.7643 34.5072 27.3997C34.5072 24.035 31.7797 21.3074 28.415 21.3074C25.0504 21.3074 22.3228 24.035 22.3228 27.3997C22.3228 30.7643 25.0504 33.4919 28.415 33.4919Z",
    fill: "#CCBCE6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3997 3.03077C27.3997 3.59155 27.8543 4.04614 28.4151 4.04614C28.9758 4.04614 29.4304 3.59155 29.4304 3.03077C29.4304 2.47 28.9758 2.0154 28.4151 2.0154C27.8543 2.0154 27.3997 2.47 27.3997 3.03077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3843 52.784C26.3843 52.2232 26.8389 51.7686 27.3997 51.7686C27.9605 51.7686 28.4151 52.2232 28.4151 52.784C28.4151 53.3447 27.9605 53.7993 27.3997 53.7993C26.8389 53.7993 26.3843 53.3447 26.3843 52.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6917 11.1537C46.6917 11.7145 46.2371 12.1691 45.6764 12.1691C45.1156 12.1691 44.661 11.7145 44.661 11.1537C44.661 10.593 45.1156 10.1384 45.6764 10.1384C46.2371 10.1384 46.6917 10.593 46.6917 11.1537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6764 45.6764C45.6764 45.1156 45.2218 44.661 44.661 44.661C44.1002 44.661 43.6456 45.1156 43.6456 45.6764C43.6456 46.2371 44.1002 46.6917 44.661 46.6917C45.2218 46.6917 45.6764 46.2371 45.6764 45.6764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7993 28.4151C53.7993 27.8543 53.3447 27.3997 52.784 27.3997C52.2232 27.3997 51.7686 27.8543 51.7686 28.4151C51.7686 28.9758 52.2232 29.4304 52.784 29.4304C53.3447 29.4304 53.7993 28.9758 53.7993 28.4151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04614 27.3997C4.04614 26.8389 3.59155 26.3843 3.03077 26.3843C2.47 26.3843 2.0154 26.8389 2.0154 27.3997C2.0154 27.9605 2.47 28.4151 3.03077 28.4151C3.59155 28.4151 4.04614 27.9605 4.04614 27.3997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 10.1384C9.123 10.6991 9.5776 11.1537 10.1384 11.1537C10.6991 11.1537 11.1537 10.6991 11.1537 10.1384C11.1537 9.5776 10.6991 9.123 10.1384 9.123C9.5776 9.123 9.123 9.5776 9.123 10.1384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 44.661C9.123 44.1002 9.5776 43.6456 10.1384 43.6456C10.6991 43.6456 11.1537 44.1002 11.1537 44.661C11.1537 45.2218 10.6991 45.6764 10.1384 45.6764C9.5776 45.6764 9.123 45.2218 9.123 44.661Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3996 5.06148H29.4304V7.09222H27.3996V5.06148Z",
    fill: "#65325f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06443 28.5349L5.05378 26.5042L7.0845 26.4935L7.09515 28.5242L5.06443 28.5349Z",
    fill: "#65325f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4813 12.021L12.9251 10.593L14.3531 12.0368L12.9093 13.4648L11.4813 12.021Z",
    fill: "#65325f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1073 44.4165L10.6718 42.9801L12.1081 41.5446L13.5437 42.9809L12.1073 44.4165Z",
    fill: "#65325f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3843 48.7224H28.415V50.7532H26.3843V48.7224Z",
    fill: "#65325f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7301 29.3212L48.7195 27.2905L50.7502 27.2798L50.7608 29.3105L48.7301 29.3212Z",
    fill: "#65325f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4615 43.7778L42.9054 42.3498L44.3334 43.7937L42.8895 45.2217L41.4615 43.7778Z",
    fill: "#65325f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7065 14.2701L42.2709 12.8338L43.7073 11.3982L45.1428 12.8345L43.7065 14.2701Z",
    fill: "#65325f"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_2",
    x: 4.06148,
    y: 4.06148,
    width: 47.6917,
    height: 47.6917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_2",
    x: 18.3228,
    y: 21.3074,
    width: 20.1845,
    height: 20.1845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_2",
    x: 18.3228,
    y: 21.3074,
    width: 20.1845,
    height: 20.1845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1_2",
    x: 0.0153999,
    y: 0.0153999,
    width: 55.7839,
    height: 55.7839,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.78569 33.9421) rotate(38.5169) scale(26.9951)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.03074 35.0149) rotate(38.5169) scale(31.7943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65325f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#65325f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65325f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinIcon);
export default __webpack_public_path__ + "static/media/spin-icon.f5513da8306e0bd471382b263be02daf.svg";
export { ForwardRef as ReactComponent };